import { useEffect, useState } from 'react';

// La parte B2C (Rivelasta prospect) è pensata SOLO per mobile. Su desktop mostriamo
// un avviso. Il B2B invece resta accessibile normalmente da PC. Marina 2026-07-14.
const MQ = '(max-width: 768px)';

export function useIsMobile() {
  const [mobile, setMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MQ).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(MQ);
    const onChange = (e) => setMobile(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return mobile;
}

export function MobileOnlyNotice() {
  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.brand}>Rivelasta</div>
        <div style={S.icon} aria-hidden="true">
          <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#16915E" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="6" y="2" width="12" height="20" rx="3" />
            <line x1="11" y1="18" x2="13" y2="18" />
          </svg>
        </div>
        <h1 style={S.h1}>Disponibile solo da mobile</h1>
        <p style={S.sub}>
          Al momento Rivelasta è disponibile solo per smartphone. Apri questo link dal tuo telefono per continuare.
        </p>
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: '100svh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(160deg, #0f172a 0%, #1e293b 100%)', padding: 24,
    fontFamily: 'Manrope, system-ui, sans-serif',
  },
  card: {
    width: '100%', maxWidth: 420, background: '#fff', borderRadius: 20, padding: '34px 28px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.35)', textAlign: 'center',
  },
  brand: { fontWeight: 800, fontSize: 18, color: '#16915E', marginBottom: 20, letterSpacing: '-0.01em' },
  icon: {
    width: 78, height: 78, borderRadius: '50%', background: '#E9F7EF',
    display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px',
  },
  h1: { fontSize: 22, fontWeight: 800, margin: '0 0 8px', color: '#0f172a' },
  sub: { fontSize: 14.5, color: '#64748b', margin: 0, lineHeight: 1.55 },
};
